import * as React from 'react';

import { Collapse } from '@mui/material';

interface CollapsibleInterface {
    expanded: boolean;
    id: string;
}

export const Collapsible: React.FC<CollapsibleInterface> = ({ children, expanded, id }) => (
    <Collapse id={id} in={expanded} timeout="auto" unmountOnExit>
        {children}
    </Collapse>
);
